module.exports = __webpack_public_path__ + "img/overseas-service2.80466b3a.jpg";